export default __webpack_public_path__ + "static/5-7683e612ebbb8458375dcdb1e20e313a.png";